/**
 * Generate absolute callback URL for OAuth redirects.
 * Uses window.location.origin to ensure the URL is always correct
 * regardless of environment (prod, stage, local).
 */
export function getAuthCallbackUrl(): string {
  return new URL('/auth/callback', window.location.origin).toString();
}
